import { render } from "./WishDetails.vue?vue&type=template&id=4c3cd6ea&scoped=true"
import script from "./WishDetails.vue?vue&type=script&lang=ts"
export * from "./WishDetails.vue?vue&type=script&lang=ts"

import "./WishDetails.vue?vue&type=style&index=0&id=4c3cd6ea&lang=scss"
import "./WishDetails.vue?vue&type=style&index=1&id=4c3cd6ea&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4c3cd6ea"

export default script